import React from "react";
import ServiceDetail from "./ServiceDetail";
import SEOBanner from "../../Components/Assets/SEO-Banner.jpeg";

function SEO() {
  return (
    <ServiceDetail
      eyebrow="SEO & Marketing"
      title="SEO & Digital Marketing Packages"
      description="Strategy-driven SEO and marketing packages built to improve visibility, attract traffic, and help your business grow online."
      ctaText="Grow My Business"

      heroImage={SEOBanner}

      packages={[
        {
          name: "SEO Starter",
          subtitle: "Best for basic visibility",
          price: 300,
          features: [
            "Basic keyword research",
            "On-page SEO setup",
            "Meta titles and descriptions",
            "Google Business Profile guidance",
            "Basic website audit",
          ],
        },
        {
          name: "SEO Growth",
          subtitle: "Best for steady growth",
          price: 750,
          featured: true,
          features: [
            "Advanced keyword research",
            "On-page SEO optimization",
            "Content strategy recommendations",
            "Technical SEO review",
            "Monthly performance report",
            "Local SEO support",
          ],
        },
        {
          name: "SEO Pro",
          subtitle: "Full digital growth support",
          price: 1500,
          features: [
            "Full SEO strategy",
            "Competitor research",
            "Content planning",
            "Technical SEO improvements",
            "Google Ads guidance",
            "Monthly reporting and insights",
          ],
        },
      ]}
      process={[
        {
          title: "Audit",
          text: "We review your website, keywords, competitors, and current online visibility.",
        },
        {
          title: "Optimize",
          text: "We improve your pages, content structure, and search visibility foundation.",
        },
        {
          title: "Grow",
          text: "We track progress and adjust the strategy to help bring in better traffic.",
        },
      ]}
    />
  );
}

export default SEO;